import { createFileRoute } from '@tanstack/react-router'
import { Recursos } from '@/features/portal/recursos'
import { PortalShell } from '@/features/portal/shell'

/** Kit de recursos liberado para o paciente. */
export const Route = createFileRoute('/_portal/portal_/recursos')({
  component: function RecursosDoPortal() {
    return (
      <PortalShell title="Recursos">
        <Recursos />
      </PortalShell>
    )
  },
})
